// Job status channel job names
export const JOB_NAMES = {
  BULK_DISCARD_ITEM_NODES: "Tools::Api::DiscardItemNodesActionJob",
  BULK_DESTROY_ITEM_NODES: "Tools::Api::DestroyItemNodesActionJob",
  DESTROY_DISCARDED_ITEM_NODES:
    "Tools::Api::DestroyDiscardedItemNodesActionJob",
  BULK_UNDISCARD_ITEM_NODES: "Tools::Api::UndiscardItemNodesActionJob",
  UNDISCARD_ITEM_NODE: "Tools::Api::UndiscardItemNodesActionJob",
  // Single and bulk publish share one job.
  PUBLISH_ITEM_NODES: "Tools::Api::PublishItemNodesActionJob",
  DUPLICATE_ACTION: "Tools::Api::DuplicateItemNodesActionJob",
  DUPLICATE_TEMPLATE_ACTION: "Tools::Api::DuplicateTemplateActionJob",
  DISCARD_ALL_AI_IMAGES: "Tools::Ai::ImagesDiscardAllJob",
  ADOPT_ITEM_NODES: "Tools::Api::AdoptItemNodesActionJob",
} as const;

// Type for job names
export type JobName = (typeof JOB_NAMES)[keyof typeof JOB_NAMES];

// Job status types
export const JOB_STATUS = {
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  FAILED: "failed",
} as const;

export type JobStatus = (typeof JOB_STATUS)[keyof typeof JOB_STATUS];

// Job status data interface
export interface JobStatusData {
  name: JobName;
  status: JobStatus;
  message?: string;
}

// Job payload interfaces
export interface SingleItemJobPayload {
  id: string;
  kind: string;
  namespace: string;
  tabId: string;
}

export interface BulkItemJobPayload {
  ids: string[];
  kind: string;
  namespace: string;
  tabId: string;
  // Folders not removed because they now hold a colleague's material.
  skippedCount?: number;
}

export type JobPayload = SingleItemJobPayload | BulkItemJobPayload;
